import { getAPIFullUrl, getAxiosConfig, handleApiError, risapi } from '../risapi';

export const getMilmaAdmins = async (params, callback) => {
    try {
        const res = await risapi.get(getAPIFullUrl('/api/milma-admin/managers', params), getAxiosConfig());
        callback(res.data);
    } catch (error) { handleApiError(error); callback({ error }); }
};

export const createMilmaAdmin = async (data, callback) => {
    try {
        const res = await risapi.post('/api/milma-admin/managers', data, getAxiosConfig());
        callback(res.data);
    } catch (error) { callback({ error }); }
};

export const updateMilmaAdmin = async (id, data, callback) => {
    try {
        const res = await risapi.put(`/api/milma-admin/managers/${id}`, data, getAxiosConfig());
        callback(res.data);
    } catch (error) { callback({ error }); }
};

export const deleteMilmaAdmin = async (id, callback) => {
    try {
        const res = await risapi.delete(`/api/milma-admin/managers/${id}`, getAxiosConfig());
        callback(res);
    } catch (error) { callback({ error }); }
};